import React from 'react';
import classNames from 'classnames';
import { useStyles } from './BetStopIcon.styles';
var BetStopIcon = function () {
    var classes = useStyles();
    return React.createElement("i", { className: classNames('fal fa-octagon', classes.container) });
};
export { BetStopIcon };
